"use client"

import React from 'react'

interface BoldTextRendererProps {
  text: string
  className?: string
}

export function BoldTextRenderer({ text, className = "" }: BoldTextRendererProps) {
  // Split text by **bold** markers and render accordingly
  const renderBoldText = (inputText: string) => {
    const parts = inputText.split(/(\*\*.*?\*\*)/g)
    
    return parts.map((part, index) => {
      // Check if this part is wrapped in **
      if (part.startsWith('**') && part.endsWith('**')) {
        // Remove the ** markers and render as bold
        const boldText = part.slice(2, -2)
        return (
          <strong key={index} className="font-semibold">
            {boldText}
          </strong>
        )
      }
      // Regular text
      return part
    })
  }

  return (
    <span className={className}>
      {renderBoldText(text)}
    </span>
  )
}


